import React from 'react'
import { Button, FormControl, FormLabel, Input, Option, Select, Stack, Typography } from '@mui/joy'
import Logo from 'assets/academix-logo-word.svg'
import useOnBoardingForm from './utils/useOnBoardingForm'
import { useNavigate } from 'react-router-dom'

type Props = {}

const OnBoardingForm = (props: Props) => {

  const {
    isLoading,
    setIsLoading,
    formValue,
    updateFormValue,
    onSubmit,
  } = useOnBoardingForm({})
  const navigate = useNavigate();


  return (
    <Stack spacing={2} sx={{ justifyContent: 'start', width: 1, }}>
      <Stack direction={{ md: 'row' }} spacing={2} alignItems={{ xs: 'center', md: 'end' }} >
        <Typography level='h1' sx={{ lineHeight: 1 }}>Welcome to</Typography>
        <img src={Logo} style={{ width: '190px', maxWidth: '90vw', height: 'fit-content', objectFit: 'contain', }} />
      </Stack>
      <Typography level='body-md' textAlign={{ xs: 'center', md: 'left' }}>🚀 Start Your Learning Adventure!</Typography>
      <Stack spacing={2}>
        <form
          onSubmit={onSubmit}
          style={{ gap: '1rem', display: 'grid' }}
        >

          <FormControl required>
            <FormLabel>Name</FormLabel>
            <Input
              type="text"
              name="name"
              placeholder="Name"
              value={formValue.name}
              onChange={e => updateFormValue('name', e.target.value)}
            />
          </FormControl>

          <FormControl required>
            <FormLabel>School</FormLabel>
            <Input
              type="text"
              name="school"
              placeholder="School"
              value={formValue.school}
              onChange={e => updateFormValue('school', e.target.value)}
            />
          </FormControl>

          <FormControl required>
            <FormLabel>Form</FormLabel>
            <Select placeholder='Select your form' onChange={(e, value)=> updateFormValue('grade', value)}>
              <Option value={'4'}>Form 4</Option>
              <Option value={'5'}>Form 5</Option>
              <Option value={'6'}>Form 6</Option>
              <Option value={'7'}>Other</Option>
            </Select>
          </FormControl>

          {
            formValue?.grade == '7' &&
            <FormControl required>
              <FormLabel>Custom Form</FormLabel>
              <Input
                type="text"
                name="customGrade"
                placeholder="Fill out your form"
                value={formValue.customGrade}
                onChange={e => updateFormValue('customGrade', e.target.value)}
              />
            </FormControl>

          }

          <FormControl required>
            <FormLabel>Phone Number</FormLabel>
            <Input
              type="text"
              name="phone"
              placeholder="Phone number"
              value={formValue.phone}
              onChange={e => updateFormValue('phone', e.target.value)}
            />
          </FormControl>

          <Stack gap={1} sx={{ mt: 2, flexDirection: 'row' }}>
            <Button
              type="submit"
              loading={isLoading}
              fullWidth
              size='lg'
            >
              Get Started  🚀
            </Button>
            <Button
              fullWidth
              size='lg'
              variant='plain'
              onClick={()=>navigate('/dashboard')}
            >
              Skip for now
            </Button>
          </Stack>
        </form>
      </Stack>
    </Stack>
  )
}

export default OnBoardingForm